<template>
  <div v-show="isLoaded" class="mClubes_container" v-observe-visibility="startAnimate">
    <img class="mClubes_img" :src="banner_clubes" alt="Banner clubes">
    <h2 class="mClubes_title" :class="{animate: animate}">Clubes</h2>
    <div class="mClubes_row" :class="{animate: animate}">
        <div class="mClubes_left">
            <img class="mClubes_four" :src="four_padel" alt="Cuatro padel">
            <hr class="mClubes_line_four">
            <img class="mClubes_camp" :src="camp_padel" alt="Padel camp">
            <hr class="mClubes_line_camp">
            <!-- <img class="mClubes_power" :src="power_padel" alt="Power padel">
            <hr class="mClubes_line_power"> -->
            <img class="mClubes_club" :src="club_padel" alt="Padel club">
            <hr class="mClubes_line_club">
        </div>
        <div class="mClubes_right">
            <img class="mClubes_map" :src="map" alt="Mapa">
        </div>
    </div>
    <h2 class="mClubes_subtitle">Sponsors</h2>
    <div class="mClubes_logos" :class="{onlySafari: isSafari}">
        <div class="mClubes_one">
            <img class="mClubes_lazaro" :class="{animate: animate}" :src="logo_lazaro" alt="Logo lazaro">
            <img class="mClubes_arquitecture" :class="{animate: animate}" :src="logo_arquitecture" alt="Logo arquitectura | contrucción | proyectos">
            <img class="mClubes_cloud" :class="{animate: animate}" :src="logo_cloud" alt="Logo cloud cost control">
            <img class="mClubes_fourp" :class="{animate: animate}" :src="logo_four" alt="Logo four padel">
        </div>
        <div class="mClubes_two">
            <img class="mClubes_stihl" :class="{animate: animate}" :src="logo_stihl" alt="Logo stihl">
            <!-- <img class="mClubes_tm" :class="{animate: animate}" :src="logo_tm" alt="Logo T&M"> -->
            <img class="mClubes_rrey" :class="{animate: animate}" :src="logo_rrey" alt="Logo Rrey">
            <img class="mClubes_jt" :class="{animate: animate}" :src="logo_jt" alt="Logo JT Carnes">
            <img class="mClubes_hoopla" :class="{animate: animate}" :src="logo_hoopla" alt="Logo Hoopla">
        </div>
        <div class="mClubes_three">
            <img class="mClubes_print" :class="{animate: animate}" :src="logo_printpoint" alt="Logo PrintPoint">
            <img class="mClubes_madelona" :class="{animate: animate}" :src="logo_madelona" alt="Logo Madelona">
            <img class="mClubes_salud" :class="{animate: animate}" :src="logo_salud" alt="Logo Salud integral">
        </div>
    </div>
  </div>
</template>

<script>
import banner_clubes from '@/assets/home/clubes_two.jpg'
import four_padel from '@/assets/cuatro_padel_one.png'
import camp_padel from '@/assets/padel_camp_one.png'
import power_padel from '@/assets/power_padel.png'
import club_padel from '@/assets/padel_club_one.png'
import map from '@/assets/map.png'
//import logo_lazaro from '@/assets/lago_lazaro_black.png'
import logo_lazaro from '@/assets/home/logo_lazaro_white.png'
//import logo_arquitecture from '@/assets/logo_architecture.png'
import logo_arquitecture from '@/assets/home/logo_architecture_white.png'
//import logo_cloud from '@/assets/logo_cloud.png'
import logo_cloud from '@/assets/home/logo_cloud_white.png'
//import logo_four from '@/assets/logo_four.png'
import logo_four from '@/assets/home/logo_four_white.png'
//import logo_stihl from '@/assets/logo_stihl.png'
import logo_stihl from '@/assets/home/logo_stihl_white.png'
import logo_tm from '@/assets/logo_tm_black.png'
//import logo_rrey from '@/assets/logo_rey.png'
import logo_rrey from '@/assets/home/logo_rey_white.png'
//import logo_jt from '@/assets/logo_jt.png'
import logo_jt from '@/assets/home/logo_jt_white.png'
import logo_hoopla from '@/assets/home/logo_hoopla_white.png'
import logo_printpoint from '@/assets/home/logo_printpoint_white.png'
import logo_madelona from '@/assets/home/logo_madelona_white.png'
import logo_salud from '@/assets/home/logo_salud_white.png'
import { mapGetters } from "vuex";
import Bowser from "bowser"; 
export default {
    name: "Support",
    data() {
        return {
            animate: false,
            isSafari: false,
            banner_clubes,
            four_padel,
            camp_padel,
            power_padel,
            club_padel,
            map,
            logo_lazaro,
            logo_arquitecture,
            logo_cloud,
            logo_four,
            logo_stihl,
            logo_tm,
            logo_rrey,
            logo_jt,
            logo_hoopla,
            logo_printpoint,
            logo_madelona,
            logo_salud,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true;
            }
        },
    },
    mounted() {},
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Clubes.scss";
</style>